'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidPin = function IoAndroidPin(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 2.5c6.9 0 12.5 5.5 12.5 12.3 0 9.2-12.5 22.7-12.5 22.7s-12.5-13.5-12.5-22.7c0-6.8 5.6-12.3 12.5-12.3z m0 16.6c2.5 0 4.5-1.9 4.5-4.3s-2-4.4-4.5-4.4-4.5 1.9-4.5 4.4 2 4.3 4.5 4.3z' })
        )
    );
};

exports.default = IoAndroidPin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-pin.js
// module id = 1922
// module chunks = 0